import React from 'react'
import {Skeleton} from 'antd'
import "./skeleton-style.scss"

export default function OvalSkeleton({height, maxWidth , borderRadius, block, size}) {
  return (
    <>
      <div className={'heading-skeleton'}
           style={{  maxWidth: maxWidth, overflow:"hidden"}}
      >
        <Skeleton.Input
          active={true}
          style={{
            maxWidth: maxWidth,
              height: height,
            borderRadius:borderRadius,
          }}
          block={block}
          size={size ? '' : size}
        />
      </div>
    </>
  )
}
